// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

// use axios
import axiosApi from './assets/js/axiosApi.js'
Vue.prototype.$axiosApi = axiosApi

// use vue-awesome-swiper
import VueAwesomeSwiper from 'vue-awesome-swiper'

// animate.css @4.11
import 'animate.css'

// mockjs
// import '@/assets/js/mockApi.js'

Vue.config.productionTip = false

/* eslint-disable no-new */

// Vuex 
import store from './store'

// main.js
import wx from 'weixin-js-sdk';
Vue.prototype.$wx = wx



Vue.prototype.$tips = new Vue;
window.vm = new Vue({
  el: '#app',
  VueAwesomeSwiper,
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js